import styled from 'styled-components';
import UpgradeAlertComponent from './component';

const StyledUpgradeAlertComponent = styled(UpgradeAlertComponent)`
  height: 32px;
  width: 32px;
  text-decoration: none;
  --webkit-appearance: none;
  margin: 0;
  padding: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  border: 1px solid var(--error900);
  border-radius: 4px;
  cursor: pointer;
  outline: none;

  svg {
    width: 24px;
    height: 24px;
  }
  svg path {
    fill: var(--error900);
  }
`;

export default StyledUpgradeAlertComponent;
